import { createAction } from '@reduxjs/toolkit';
export const FETCH_ANALYTIC_TEAM_MEMBER = 'FETCH_ANALYTIC_TEAM_MEMBER';
export const fetchAnalyticTeamMemberAction = createAction(FETCH_ANALYTIC_TEAM_MEMBER);